import React from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./components/homepage/HomePage";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="bgcolor_home">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

// "homepage": "/zpl",
// basename="/zpl"
